
import {request} from './request'
const literatureApi={
  //列表
  getList:params=>{
    let params2={
      ...params,
      page:params.page || 1,
      pageSize:params.pageSize?params.pageSize:9,
      keywords:params.keywords?params.keywords:'',
      is_top: -1,    //是否置顶
      city:params.city || '',
      task_year:params.task_year || '',
      typeid:params.typeid || -1,
      is_award: params.is_award>=0?params.is_award: -1,
      category:params.category || -1,
      activity_id:params.activity_id || -1,
      recommend:params.recommend || -1,
    }
    return request({url: '/TLiterature/GetList',params:params2});
  },
  

  //单一文学内容
  getOneById:params=>{
    // id
    return request({url: '/TLiterature/GetById',params:params});
  },
  
  getBookContentById: t_id => request({url: '/TLiterature/GetListResource', params: {t_id}}),
  getBookMenuById: t_id => request({url: '/TLiterature/GetListCatalogue', params: {t_id}}),

  getCateList() {
    return new Promise((resolve, reject) => {
      request({url: '/TLiterature/GetTypeIdList'})
        .then((res) => {
          for (let i in res) {
            if (i.indexOf('data') != -1) {
              const list = res[i] || []
              const name = '其他'
              const index = list.findIndex(v => v.name == name)
              if (index != -1) {
                let row = list.find(v => v.name == name)
                row = JSON.parse(JSON.stringify(row))
                list.splice(index, 1)
                list.push(row)
              }
            }
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default literatureApi